export default __webpack_public_path__ + "static/media/eye.0049f193.svg";